import React, { useState, useRef } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import CustomeFormInputField from "../FormFields/CustomeFormInputField";
import { useDispatch, useSelector } from "react-redux";
import Button from "../Button/Button";
import { ParentAddKidID, VarifyOTPParentAddKidID } from "../../api/StudentService/StudentServide";
import { useAuth } from "../../hooks/useAuth";
import { useSnackbar } from "../MUIComponent/FeedbackComponent/SnackBar/SnackbarContext";
import { Roles } from "../../constants/params/constants";
import { useParentKidAuth } from "../../hooks/parentKidUseAuth";
import { loginKidSuccess } from "../../features/auth/kidAuthSlice";
import { loginSuccess } from "../../features/auth/authSlice";
import configAPI from "../../api/config";

const AddNewChildForm = ({ onSuccess }) => {
    const theme = useTheme();
    const { user } = useAuth();
    const dispatch = useDispatch();
    const { parentkidUser } = useParentKidAuth();
    const { showSnackbar } = useSnackbar();
    const schoolID = user && user.schoolID;
    const [regNo, setRegNo] = useState("");
    const [showOtp, setShowOtp] = useState(false);
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const [generatedOtp, setGeneratedOtp] = useState("");
    const [error, setError] = useState("");  
    const [isLoading, setIsLoading] = useState(false);  
    const customColors = useSelector((state) => state.theme.customColors);

    const inputsRef = useRef([]);


     const getProfileImageURL = (student) => {
        let profileImage = student.profileImage;
        let ImageUrl = `${configAPI.REACT_APP_IMAGE_DYNAMIC_URL}/`;
    
        // Step 1: If null, parse documents
        if (!profileImage && student.documents) {
            try {
                const docs = JSON.parse(student.documents);
                const profileDoc = docs.find(
                    doc => doc.DocumentName === "Profile Image"
                );
                if (profileDoc) {
                    profileImage = profileDoc.DocumentImage;
                }
            } catch (err) {
                return null;
            }
        }
    
        // Step 2: Full URL
        const ProfileImageURL = profileImage
            ? `${configAPI.REACT_APP_IMAGE_DYNAMIC_URL}${profileImage.startsWith('/') ? '' : '/'}${profileImage}`
            : null;
    
        return ProfileImageURL;
    };

    const handleSendOtp = async () => {
       const payload = {
              EmailID : parentkidUser?.roleName === Roles[3].RoleName && parentkidUser?.email  || user?.roleName === Roles[3].RoleName && user?.email,
              RegistrationNumber: regNo,
              SchoolID: user?.schoolID|| parentkidUser?.schoolID || null
            }
    
            if (!schoolID) return;
            try {
                setIsLoading(true);
                const res = await ParentAddKidID(payload);
            if (res?.success) {
                 setShowOtp(true);
                 setError("");
            } else{
                 setShowOtp(false);
                 setError("Registration number is invalid");
            }
            } catch (error) {
                showSnackbar('Failed to load classes', error);
            } finally {
                setIsLoading(false);
            }
        
    };


    const handleOtpChange = (value, index) => {
        if (!/^[0-9]?$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        setError("");

        if (value && index < 5) {
            inputsRef.current[index + 1].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputsRef.current[index - 1].focus();
        }
    };

    const handleVerifyOtp = async () => {
        const finalOtp = otp.join("");

        const payload = {
              EmailID : parentkidUser?.roleName === Roles[3].RoleName && parentkidUser?.email  || user?.roleName === Roles[3].RoleName && user?.email,
              RegistrationNumber: regNo,
              OTP: finalOtp,
              SchoolID: user?.schoolID|| parentkidUser?.schoolID || null
            }
    
            if (!schoolID) return;
            try {
            setIsLoading(true);
            const res = await VarifyOTPParentAddKidID(payload);
                if (res?.success) {
                    const newChild = {
                        studentID: res.studentID,
                        name: res.studentName,
                        photo: getProfileImageURL(res),
                        schoolName: res.schoolName,
                        parentID: res.parentID
                    };

                 const rawChildrenList = [
                    ...(user?.parentStudentList ||
                        parentkidUser?.parentStudentList ||
                        [])
                    ];

                    const newdata = { 
                        parentID: res.parentID, 
                        parentName: res.parentName,
                        studentID: res.studentID,
                        studentName: res.studentName,
                        documents: res.documents,
                        schoolID: res.schoolID,
                        schoolName: res.schoolName,
                    };

                 

                    rawChildrenList.push(newdata);

                    // Apply updated children list based on who has the correct role
                    if (user?.roleName === Roles[3].RoleName) {
                        dispatch(loginSuccess({
                            ...user,
                            parentStudentList: rawChildrenList
                        }));
                    }

                    if (parentkidUser?.roleName === Roles[3].RoleName) {
                        dispatch(loginKidSuccess({
                            ...parentkidUser,
                            parentStudentList: rawChildrenList
                        }));
                    }
                    onSuccess(newChild);

                    setShowOtp(false);
                    setRegNo("");
                    setOtp(["", "", "", "", "", ""]);
                    setError(""); 
                } else {
                    setError("Invalid OTP. Please try again.");   
                }
            } catch (error) {
                showSnackbar('Failed to load classes', 'error');
            } finally {
                setIsLoading(false);
            }

      
    };

    return (
        <Box display="flex" flexDirection="column" gap={2}>

            {/* REG NO SECTION */}
            <Box display="flex" gap={1} alignItems="center" mt={2}>
                <CustomeFormInputField
                    fullWidth
                    label="Registration No."
                    value={regNo}
                    onChange={(e) => setRegNo(e.target.value)}
                    required
                />

                <Button
                    sx={{
                        minWidth: 90,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    bgColor={customColors?.activeButton || theme.palette.background.bgpurple}
                    textColor={theme.palette.background.textwhite}
                    disabled={!regNo}
                    onClick={handleSendOtp}
                >
                    Send OTP
                </Button>
            </Box>

            {/* OTP SECTION */}
            {showOtp && (
                <Box p={2} display="flex" flexDirection="column" gap={2}>

                    <Box display="flex" gap={1} justifyContent="center">
                        {otp.map((digit, index) => (
                            <Box
                                key={index}
                                component="input"
                                type="text"
                                value={digit}
                                maxLength={1}
                                ref={(el) => (inputsRef.current[index] = el)}
                                onChange={(e) => handleOtpChange(e.target.value, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                sx={{
                                    width: "35px",
                                    height: "35px",
                                    textAlign: "center",
                                    fontSize: "15px",
                                    borderRadius: "8px",
                                    border: `1px solid ${
                                        error ? "red" : customColors?.activeButton || theme.palette.background.bgpurple
                                    }`,
                                    outline: "none",
                                    "&:focus": {
                                        border: `2px solid ${customColors?.activeButton || theme.palette.background.bgpurple}`,
                                        outline: "none",
                                    },
                                }}
                            />
                        ))}
                    </Box>

                    {error && (
                        <Typography sx={{ color: "red", textAlign: "center", fontSize: "14px", mt: -1 }}>
                            {error}
                        </Typography>
                    )}

                    <Typography sx={{ textAlign: "center", fontWeight: 700, color: "green" }}>
                        OTP: {generatedOtp}
                    </Typography>

                    <Button
                        sx={{ minWidth: 90, alignSelf: "center" }}
                        bgColor={customColors?.activeButton || theme.palette.background.bgpurple}
                        textColor={theme.palette.background.textwhite}
                        disabled={otp.join("").length !== 6}
                        onClick={handleVerifyOtp}
                    >
                        Verify OTP
                    </Button>
                </Box>
            )}

        </Box>
    );
};

export default AddNewChildForm;
